/* @flow */

import * as React from 'react';
import { inject, observer } from 'mobx-react';
import { translate } from 'react-i18next';
import type { TranslatorProps } from 'react-i18next';

import type TypeActionDrawerStore from 'stores/ActionDrawerStore.js';

import Loading from 'components/Loading/Loading';

import ActionDrawerHeader from '../../../components/ActionDrawerHeader/ActionDrawerHeader';
import UnarchiveCostCenterForm from './UnarchiveCostCenterForm/UnarchiveCostCenterForm';
import UnarchiveCostCenterSuccess from './UnarchiveCostCenterSuccess/UnarchiveCostCenterSuccess';
import UnarchiveCostCenterError from './UnarchiveCostCenterError/UnarchiveCostCenterError';
import Form from '../../../../../forms/_.extend';

import styles from '../../../ActionDrawer.module.scss';

type TypeProps = {|
  formData: Object,
  actionDrawerStore: TypeActionDrawerStore,
|} & TranslatorProps;

@translate()
@inject('actionDrawerStore')
@observer
export default class UnarchiveCostCenter extends React.Component<*> {
  createForm = () => {
    const { t }: TranslatorProps = this.props;
    const { actionDrawerStore }: TypeProps = this.props;
    const costCenter: Object = this.props.formData;
    const fields: Array<Object> = [
      {
        name: 'unarchiveCostCenterForm',
        label: t('general:actions.unarchive_cost_center'),
        title: 'Unarchive Cost Center',
        fields: [
          {
            name: 'reason',
            label: t('general:reasons.provide_reason'),
            rules: 'required',
            value: '',
          },
        ],
      },
    ];

    const hooks: Object = {
      onSuccess(data: Object) {
        const {
          reason,
        }: //reason text
        Object = data.values().unarchiveCostCenterForm;

        actionDrawerStore.unarchiveCostCenter(costCenter.id, {
          activity_reason: reason,
        });
      },
    };

    return new Form(
      { fields },
      {
        hooks,
        options: {
          validateOnInit: true,
          validateOnChange: true,
        },
        name: 'Unarchive Cost Center',
      }
    );
  };

  render(): React.Element<*> {
    const { t }: TranslatorProps = this.props;
    const { actionDrawerStore }: TypeProps = this.props;
    const costCenter: Object = this.props.formData;

    if (actionDrawerStore.loading) {
      return <Loading />;
    }

    if (actionDrawerStore.error) {
      return (
        <div className={`${styles['action-drawer-form']} ${styles.error}`}>
          <ActionDrawerHeader title={t('general:actions.unarchive_cost_center')} />
          <UnarchiveCostCenterError costCenter={costCenter} response={actionDrawerStore.response} />
        </div>
      );
    }

    if (actionDrawerStore.success) {
      return (
        <div className={`${styles['action-drawer-form']} ${styles.success}`}>
          <ActionDrawerHeader title={t('general:actions.unarchive_cost_center')} />
          <UnarchiveCostCenterSuccess response={actionDrawerStore.response} />
        </div>
      );
    }

    return (
      <div className={styles['action-drawer-form']}>
        <ActionDrawerHeader title={t('general:actions.unarchive_cost_center')} />
        <UnarchiveCostCenterForm costCenter={costCenter} form={this.createForm()} />
      </div>
    );
  }
}
